import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=58a1541a&scoped=true&"
import script from "./TreeNode.vue?vue&type=script&lang=js&"
export * from "./TreeNode.vue?vue&type=script&lang=js&"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=58a1541a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1541a",
  null
  
)

export default component.exports